import BulkUploadFailuresByReason, { BulkFailureItem } from '../BulkUploadFailuresByReason';
import { ErrorOutlineOutlined as ErrorIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { DialogContent, DialogActions } from '@mui/material';
import SectionHeader from '../../SectionHeader';
import { GlobalButton } from '@/components';

interface FailedResultViewProps {
  resultMessage: string;
  failures: BulkFailureItem[];
  onClose: () => void;
}

const FailedResultView = ({ resultMessage, failures, onClose }: FailedResultViewProps) => (
  <>
    <DialogContent sx={{ pb: 1 }}>
      <div className='flex flex-col'>
        <SectionHeader
          title='Pedidos no procesados'
          icon={ErrorIcon}
          colorClass='bg-red-500'
        />
        <p className='text-gray-600 text-[15px] leading-relaxed font-medium px-1'>
          {resultMessage}
        </p>
        <BulkUploadFailuresByReason failures={failures} />
      </div>
    </DialogContent>
    <DialogActions className='px-6 pb-6 gap-3'>
      <GlobalButton action={onClose} variant={GlobalButtonVariant.primaryButton}>
        Cerrar
      </GlobalButton>
    </DialogActions>
  </>
);

export default FailedResultView;
